// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { Link, useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//     fetchProducts,
//     selectProducts,
//     selectProductLoading,
//     selectProductError,
// } from "../redux/productSlice";
// import Slider from "react-slick";
// import LoadingSpinner from "../component/loadingSpinner";
// import { Button, Col, Container, Modal, Row } from "react-bootstrap";
// import Navigation from "../component/navigation";
// import {
//     increaseQuantity,
//     decreaseQuantity,
//     addToCart,
//     removeFromCart,
// } from "../redux/cartSlice";
// import {
//     toggleWishlist,
//     handleAddToCart,
//     handleRemoveProduct,
// } from "../utils/productAction";
// import { BsCart2, BsCartPlusFill, BsDashLg, BsHeart, BsHeartFill, BsPlusLg, BsRepeat, BsTruck, BsWallet } from "react-icons/bs";
// import { AiOutlineShoppingCart } from "react-icons/ai";
// import ReactImageMagnify from "react-image-magnify";
// import Tab from "react-bootstrap/Tab";
// import Tabs from "react-bootstrap/Tabs";
// import ReviewForm from "../component/rating";
// import { FaRegStar, FaStar } from "react-icons/fa";
// import QandA from "../component/qAndA";
// import ProductCard from "../component/productCard";
// import { calculateDiscountAndFinalPrice } from "../utils/priceCalculation";
// import Footer from "../component/footer";
// import { addToCompare } from "../redux/compareSlice";
// import "../css/productDetails.css"
// import StartRating from "../component/starRating";
// import { calculateAverageRating } from "../utils/calculateAverageRating";
// import { selectAverageRating, selectNumberOfReviews } from '../redux/reviewSlice';
// import Compare from '../page/compare'
// // import { selectAverageRating, selectNumberOfReviews } from '../utils/reviewSelector'

// const ProductDetail = () => {
//     const { id } = useParams();
//     const dispatch = useDispatch();
//     const products = useSelector(selectProducts);
//     const status = useSelector(selectProductLoading);
//     const error = useSelector(selectProductError);

//     const cartItems = useSelector((state) => state.cart.cartItems);
//     const wishlistItems = useSelector((state) => state.wishlist.wishlistItems);
//     const comparisonItems = useSelector((state) => state.compare.compareItems);
//     const [isAddedW, setIsAddedW] = useState(false);
//     const [isAdded, setIsAdded] = useState(false);
//     const [quantity, setQuantity] = useState(1); // Local quantity state

//     const [showModal, setShowModal] = useState(false);
//     const [activeSlide, setActiveSlide] = useState(0);
//     // const productIdSreview = Number(id);

//     const product = useMemo(() => {
//         return products.find((item) => Number(item.id) === Number(id));
//     }, [products, id]);

//  const combinedImages = useMemo(() => {
//     return product ? [...(product.images || []), product.image] : [];
// }, [product]);

//     const cartItem = useMemo(() => {
//         return cartItems.find((item) => item.id === product?.id);
//     }, [cartItems, product]);

//     const isWishlisted = useMemo(() => {
//         return wishlistItems.some((item) => item.id === product?.id);
//     }, [wishlistItems, product]);

//     const regularPrice = useMemo(() => product?.price || 0, [product?.price]);

//     const { finalPrice } = useMemo(() => {
//         return product ? calculateDiscountAndFinalPrice(product.price, product.discount) : { finalPrice: 0 };
//     }, [product?.price, product?.discount]);

//     const relatedProducts = useMemo(() => {
//         // Stable filtering, only changes when `products` or `product` changes
//         if (product) {
//             return products.filter(
//                 (item) => item.category === product.category && item.id !== product.id
//             );
//         }
//         return [];
//     }, [products, product?.category, product?.id]);

//     useEffect(() => {
//         window.scrollTo(0, 0);
//     }, []);

//     useEffect(() => {
//         if (!products.length) {  // Only fetch if products haven't already been loaded
//           dispatch(fetchProducts());
//         }
//       }, [dispatch, products.length]);

//     useEffect(() => {
//         if (cartItem) {
//             setQuantity(cartItem.quantity); // Sync local quantity with cart if product is in the cart
//         }
//     }, [cartItem]);

//     useEffect(() => {
//         if (cartItem) {
//             // If the product is already in the cart, use its quantity.
//             setQuantity(cartItem.quantity);
//         } else {
//             // If it's a new product, reset the quantity to 1.
//             setQuantity(1);
//         }
//     }, [cartItem, id]);

//     const increaseLocalQuantity = useCallback(() => {
//         if (cartItem) {
//             // If product is in the cart, dispatch the increaseQuantity action
//             dispatch(increaseQuantity({ id: product.id }));
//         } else {
//             // If not in the cart, update the local quantity
//             setQuantity((prevQuantity) => prevQuantity + 1);
//         }
//     }, [dispatch, cartItem, product]);

//     const decreaseLocalQuantity = useCallback(() => {
//         if (cartItem) {
//             // If product is in the cart, dispatch the decreaseQuantity action
//             dispatch(decreaseQuantity({ id: product.id }));
//         } else {
//             // If not in the cart, update the local quantity
//             setQuantity((prevQuantity) =>
//                 prevQuantity > 1 ? prevQuantity - 1 : 1
//             );
//         }
//     }, [dispatch, cartItem, product]);

//     const handleAddProductToCart = useCallback(() => {
//         // Ensure quantity is passed correctly
//         const updatedProduct = { ...product, quantity };

//         // Call the handleAddToCart function with product details, cartItems, and dispatch
//         handleAddToCart(dispatch, updatedProduct, cartItems, setIsAdded);

//         // Debugging line
//     }, [dispatch, product, quantity, cartItems]);

//     // const handleRemoveProductDetails = useCallback(() => {
//     //     handleRemoveProduct(dispatch, product.id, cartItems);
//     // }, [dispatch, product.id, cartItems]);

//     const handleRemoveProductDetails = useCallback(() => {
//         if (product && product.id) {
//             handleRemoveProduct(dispatch, product.id, cartItems);
//         }
//     }, [dispatch, product, cartItems]);

//     const handleWishlistToggle = useCallback(() => {
//         toggleWishlist(
//             dispatch,
//             product,
//             wishlistItems,
//             isWishlisted,
//             setIsAddedW
//         );
//     }, [dispatch, product, wishlistItems, isWishlisted]);

//     const handleAddToComparison = useCallback(() => {

//         dispatch(addToCompare({ ...product, finalPrice }));

//     }, [dispatch, product, finalPrice]);
//     const productId = product?.id;

//     const averageRating = useSelector(
//         useCallback((state) => selectAverageRating(state,productId), [productId])
//       );

//       const numberOfReviews = useSelector(
//         useCallback((state) => selectNumberOfReviews(state, productId), [productId])
//       );
//     console.log('Average Rating:', averageRating); // Debugging
//     console.log('Number of Reviews:', numberOfReviews);
//  const settings = useMemo(() => ({
//     customPaging: function (i) {
//         return (
//             <a key={i}>
//                 <img
//                     src={combinedImages[i]}
//                     alt={`Thumb ${i}`}
//                 />
//             </a>
//         );
//     },
//     dots: true,
//     dotsClass: "slick-dots slick-thumb",
//     infinite: true,
//     centerPadding: "0px",
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     afterChange: (index) => setActiveSlide(index),
// }), [combinedImages]);

// const relatedProductSettings = useMemo(() => ({
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     responsive: [
//         { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
//         { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
//         { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } }
//     ]
// }), []);

// // Fetch combined reviews from reviewSlice

//    if (!product) {
//     return <LoadingSpinner />;
//  }

//     return (
//         <>
//             <Navigation />
//             <div className="productdetails">
//                 <Container fluid>
//                     <Row className="productdetails-mainslider">
//                         <Col md={6}>
//                             <Slider {...settings}>
//                                 {combinedImages.map((image, index) => (
//                                     <div
//                                         key={index}
//                                         onClick={() => setShowModal(true)}
//                                     >
//                                         <img
//                                             src={image}
//                                             alt={`Slide ${index}`}
//                                             className="productdetails-mainslider-main-image"
//                                             style={{

//                                                 cursor: "pointer",
//                                             }}
//                                         />
//                                     </div>
//                                 ))}
//                             </Slider>
//                         </Col>
//                         <Col md={6}>
//                             <Row>
//                                 <Col md={12}>
//                                     <Tabs
//                                         defaultActiveKey="details"
//                                         id="uncontrolled-tab-example"
//                                         className="mb-3"
//                                     >
//                                         <Tab eventKey="details" title="Details">
//                                             <div className="productINfoDetails">

//                                                 <h2 className="productInfoName">{product.name}
//                                                 {/* {finalPrice.toFixed(2) ===
//                                                 product.price.toFixed(2) ? (
//                                                   ''
//                                                 ):(
//                                                    <span style={{color:'rgba(203, 28, 30, 1)'}}> &nbsp;( {product.discount} OFF)</span>
//                                                 )} */}

//                                                     </h2>
//                                                     <p className="productInfoRating d-flex align-items-center gap-1">
//                                                     <ul id="stars" className="d-flex list-unstyled p-0 m-0">
//                                                         <StartRating productRating={averageRating.toFixed(1)} />
//                                                     </ul>
//                                                     <span>{averageRating.toFixed(1)}</span>
//                                                     <span>({numberOfReviews} Reviews)</span>
//                                                 </p>
//                                                 {finalPrice.toFixed(2) ===
//                                                 product.price.toFixed(2) ? (
//                                                     <p  className="productInfoRegular d-flex flex-column">
//                                                     <span>Regular Price:</span>
//                                                     <span>TK  {regularPrice.toFixed(2)}</span>

//                                                 </p>
//                                                 ) : (
//                                                     <>
//                                                        <p  className="productInfoFinalPrice d-flex flex-column">
//                                                             <span>Discount Price:</span>
//                                                             <span>TK {finalPrice.toFixed(2)}</span>
//                                                             <span>{finalPrice.toFixed(2) ===
//                                                 product.price.toFixed(2) ? (
//                                                   ''
//                                                 ):(
//                                                    <span style={{color:'rgba(203, 28, 30, 1)'}}>  {product.discount} OFF</span>
//                                                 )}</span>
//                                                         </p>

//                                                         <p  className="productInfoRegular d-flex flex-column">
//                                                             <span>Regular Price:</span>
//                                                             <span>TK  {regularPrice.toFixed(2)}</span>

//                                                         </p>
//                                                     </>
//                                                 )}

//                                                 <p className="productInfoDeleveryTime">
//                                                     Delivery Time: <span>{product.deleveryTime
//                                                 }</span>{product.deliveryTime}
//                                                     <h2 className="productInfoDeleveryime"></h2>
//                                                 </p>
//                                                 <div className="quickOverView">
//                                                     <h4>Quick Overview</h4>
//                                                     <ul>
//                                                         {product.quickOverview && product.quickOverview.length > 0 ? (
//                                                             product.quickOverview.map((item, index) => {
//                                                             const [key, value] = Object.entries(item)[0]; // Destructure key and value from each object
//                                                             return (
//                                                                 <li key={index}>
//                                                                 {key} - {value}
//                                                                 </li>
//                                                             );
//                                                             })
//                                                         ) : (
//                                                             <li>No Quick Overview available</li>
//                                                         )}
//                                                       </ul>
//                                                 </div>

//                                                 <div className="product-actions productInfoAddToCart d-flex gap-2">
//                                                 <div
//                                                     className="quantity-controls productInfoControls"
//                                                     style={{
//                                                         display: "flex",
//                                                         alignItems: "center",
//                                                         gap: "10px",
//                                                     }}
//                                                 >
//                                                     <button className="minus"
//                                                         onClick={decreaseLocalQuantity}
//                                                         disabled={quantity <= 1}
//                                                     >
//                                                        <BsDashLg />
//                                                     </button>
//                                                     <span className="input-box">{quantity}</span>
//                                                     <button className="plus"
//                                                         onClick={increaseLocalQuantity}
//                                                     >
//                                                      <BsPlusLg />
//                                                     </button>
//                                                 </div>
//                                                     <button
//                                                         className={`add-to-cart-btn ${
//                                                             cartItem ? "added" : ""
//                                                         }`}
//                                                         onClick={
//                                                             cartItem
//                                                                 ? handleRemoveProductDetails
//                                                                 : handleAddProductToCart
//                                                         }
//                                                     >

//                                                         {cartItem
//                                                             ?(<p><BsCartPlusFill /> Remove From Cart</p>)
//                                                             :(<p><AiOutlineShoppingCart /> Add To Cart</p>)

//                                                             }
//                                                     </button>
//                                                     <button
//                                                         className="compare-btn"
//                                                         onClick={handleAddToComparison}
//                                                     >
//                                                        <BsRepeat />  Compare
//                                                     </button>
//                                                     <button
//                                                         className={`wishlist-btn ${
//                                                             isWishlisted ? "wishlisted" : ""
//                                                         }`}
//                                                         onClick={handleWishlistToggle}
//                                                     >
//                                                         {isWishlisted ? <BsHeartFill /> : <BsHeart />}{" "}
//                                                         {isWishlisted
//                                                             ? ""
//                                                             : ""}
//                                                     </button>

//                                                 </div>
//                                                 <div className="btn-group-sop d-flex gap-1">
//                                                     <button className="btn btn-primary"><BsTruck /> Shipping & Charge</button>
//                                                     <button className="btn btn-primary"><BsCart2 />  Order Procedure</button>
//                                                     <button className="btn btn-primary"><BsWallet /> Payment Method</button>

//                                                 </div>
//                                             </div>
//                                         </Tab>
//                                         <Tab eventKey="home" title="Specifications">
//                                         <div className="product-tabs">
//         {/* Description Tab */}
//         {/* <div className="tab-pane">
//           <h2>Description</h2>
//           <p>{product.description}</p>
//         </div> */}

//         {/* Specifications Tab */}

//           {/* Check if product has specifications */}
//           {product.specifications && product.specifications.length > 0 ? (
//             <div className="specifications-list">
//               {product.specifications.map((spec, index) => (
//                 <div key={index} className="spec-item">
//                   <h3>{spec.title}</h3>
//                   {/* Check if the description is an array (list) or string */}
//                   {Array.isArray(spec.description) ? (
//                     <ul>
//                       {spec.description.map((desc, i) => (
//                         <li key={i}>{desc}</li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <p>{spec.description}</p>
//                   )}
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <p>No specifications available for this product.</p>
//           )}
//         </div>

//                                         </Tab>
//                                         <Tab eventKey="compare" className="productComparenavbar" title="Product Compare">
//                                             <Compare compareLimit={4}/>
//                                             {comparisonItems.length >= 4 && (
//               <div className="mt-3">
//                 <Link to="/compare">Go to Compare Page</Link>
//               </div>
//             )}
//                                             {/* {comparisonItems.length>=4 &&(
//                                                 <>
//                                                  <Compare />
//                                                  <Link to="/compare">Go to Compare Page</Link>
//                                                 </>

//                                             )} */}
//                                        </Tab>
//                                         <Tab eventKey="contact" title="Q & A">
//                                         <QandA productId={product.id} />
//                                         </Tab>
//                                         <Tab eventKey="review" title="Review">
//                                             {/* <h4>Customer Reviews</h4>
//                                             <p>
//   <FaStar /> {averageRating} out of 5.0
// </p>
// <p>Total Reviews: {totalReviews}</p>
//                                             <ReviewForm productId={product.id}/> */}
// <ReviewForm productId={product.id} />

//                                             {/* Optional: Display list of reviews */}
//                                             {/* <div className="reviews-section">
//                                                 {product.reviewsList.map((review, index) => (
//                                                     <div key={index} className="review-item">
//                                                         <h5>{review.name}</h5>
//                                                         <StartRating productRating={review.PersonRating} />
//                                                         <p>{review.review}</p>
//                                                     </div>
//                                                 ))}
//                                             </div> */}

//                                         </Tab>
//                                     </Tabs>
//                                     <br /><br />
//                                 </Col>
//                             </Row>
//                         </Col>
//                     </Row>

//                     <Row>
//                         <Col md={12}>
//                             <br /><br />
//                             <h3>Related Products</h3><br />
//                             <Slider {...relatedProductSettings}>
//                                 {relatedProducts.map((relatedProduct) => (
//                                     <ProductCard
//                                         key={relatedProduct.id}
//                                         product={relatedProduct}
//                                     />
//                                 ))}
//                             </Slider>
//                         </Col>
//                     </Row>
//                 </Container>
//                 <Modal
//                     show={showModal}
//                     onHide={() => setShowModal(false)}
//                     size="lg"
//                     centered
//                 >
//                     <Modal.Header closeButton>
//                         <Modal.Title>Product Images</Modal.Title>
//                     </Modal.Header>
//                     <Modal.Body>
//                         {/* Popup Slick Slider */}
//                         <Row>
//                             <Col md={6} className="productimageslick">
//                                 <Slider
//                                     {...settings}
//                                     initialSlide={activeSlide}
//                                 >
//                                     {combinedImages.map((image, index) => (
//                                         <div key={index}>
//                                             <ReactImageMagnify
//                                                 {...{
//                                                     smallImage: {
//                                                         alt: `Slide ${index}`,
//                                                         isFluidWidth: true,
//                                                         src: image,
//                                                     },
//                                                     largeImage: {
//                                                         src: image,
//                                                         width: 1000,
//                                                         height: 1000,
//                                                     },
//                                                     enlargedImagePosition: "over",
//                                                     enlargedImageContainerDimensions: {
//                                                         width: "100%",
//                                                         height: "100%",
//                                                     },
//                                                     enlargedImageContainerStyle: {
//                                                         zIndex: "999900",
//                                                         width: '100%',
//                                                         height: '100%',
//                                                         left: '50%',
//                                                         top: '50%',
//                                                         transform: 'translate(-50%,-50%)',
//                                                         border: '4px solid #f1f1f1',
//                                                         backgroundColor: 'rgba(255, 255, 255, 0.8)',
//                                                     },
//                                                     enlargedImageStyle: {
//                                                         objectFit: 'contain',
//                                                         width: '100%',
//                                                         height: '100%',
//                                                     },
//                                                     lensStyle: {
//                                                         backgroundColor: 'rgba(0, 0, 0, 1)',
//                                                         border: '1px solid red',
//                                                     },
//                                                 }}
//                                             />
//                                         </div>
//                                     ))}
//                                 </Slider>
//                             </Col>
//                             <Col md={6} className="showzomingimg">
//                                 <div>
//                                     <iframe
//                                         width="100%"
//                                         height="315"
//                                         src="https://www.youtube.com/embed/ngElkyQ6Rhs"
//                                         frameBorder="0"
//                                         allowFullScreen
//                                         title="Product Video"
//                                     ></iframe>
//                                 </div>
//                             </Col>
//                         </Row>
//                     </Modal.Body>
//                     <br /><br /><br />
//                     <Modal.Footer>
//                         <Button
//                             variant="secondary"
//                             onClick={() => setShowModal(false)}
//                         >
//                             Close
//                         </Button>
//                     </Modal.Footer>
//                 </Modal>

//             </div>
//             <br /><br /><br />
//             <Footer />
//         </>
//     );
// };

// export default React.memo(ProductDetail);

import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts, selectProducts } from "../redux/productSlice";
import Slider from "react-slick";
import LoadingSpinner from "../component/loadingSpinner";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import Navigation from "../component/navigation";
import {
    BsCart2,
    BsCartPlusFill,
    BsDashLg,
    BsHeart,
    BsHeartFill,
    BsPlusLg,
    BsRepeat,
    BsTruck,
    BsWallet,
} from "react-icons/bs";
import { AiOutlineShoppingCart } from "react-icons/ai";
import ReactImageMagnify from "react-image-magnify";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import ReviewForm from "../component/rating";
import QandA from "../component/qAndA";
import ProductCard from "../component/productCard";
import Footer from "../component/footer";
import "../css/productDetails.css";
import StartRating from "../component/starRating";
import Compare from "../page/compare";
import useProductActions from "../utils/productThanos";

const ProductDetail = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const products = useSelector(selectProducts);
    const [showModal, setShowModal] = useState(false);
    const [activeSlide, setActiveSlide] = useState(0);
    const product = useMemo(() => {
        return products.find((item) => Number(item.id) === Number(id));
    }, [products, id]);
    const {
        cartItem,
        isWishlisted,
        compareItems,
        isComparelisted,
        combinedImages,
        finalPrice,
        regularPrice,
        quantity,
        averageRating,
        numberOfReviews,
        handleAddToCards,
        handleRemoveProductDetails,
        increaseLocalQuantity,
        decreaseLocalQuantity,
        handleAddToWishlist,
        handleCompareProduct,
    } = useProductActions(product);

    const relatedProducts = useMemo(() => {
        // Stable filtering, only changes when `products` or `product` changes
        if (product) {
            return products.filter(
                (item) =>
                    item.category === product.category && item.id !== product.id
            );
        }
        return [];
    }, [products, product?.category, product?.id]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!products.length) {
            // Only fetch if products haven't already been loaded
            dispatch(fetchProducts());
        }
    }, [dispatch, products.length]);

    const settings = useMemo(
        () => ({
            customPaging: function (i) {
                return (
                    <a key={i}>
                        <img src={combinedImages[i]} alt={`Thumb ${i}`} />
                    </a>
                );
            },
            dots: true,
            dotsClass: "slick-dots slick-thumb",
            infinite: true,
            centerPadding: "0px",
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: (index) => setActiveSlide(index),
        }),
        [combinedImages]
    );

    const relatedProductSettings = useMemo(
        () => ({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: { slidesToShow: 3, slidesToScroll: 1 },
                },
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 2, slidesToScroll: 1 },
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 1, slidesToScroll: 1 },
                },
            ],
        }),
        []
    );

    // Fetch combined reviews from reviewSlice
    useEffect(() => {
        console.log("Current Product ID:", product?.id);
    }, [product?.id]);

    if (!product) {
        return <LoadingSpinner />;
    }

    return (
        <>
            <Navigation />
            <div className="productdetails">
                <Container fluid>
                    <Row className="productdetails-mainslider">
                        <Col md={6}>
                            <Slider {...settings}>
                                {combinedImages.map((image, index) => (
                                    <div
                                        key={index}
                                        onClick={() => setShowModal(true)}
                                    >
                                        <img
                                            src={image}
                                            alt={`Slide ${index}`}
                                            className="productdetails-mainslider-main-image"
                                            style={{
                                                cursor: "pointer",
                                            }}
                                        />
                                    </div>
                                ))}
                            </Slider>
                        </Col>
                        <Col md={6}>
                            <Row>
                                <Col md={12}>
                                    <Tabs
                                        defaultActiveKey="details"
                                        id="uncontrolled-tab-example"
                                        className="mb-3"
                                    >
                                        <Tab eventKey="details" title="Details">
                                            <div className="productINfoDetails">
                                                <h2 className="productInfoName">
                                                    {product.name}
                                                    {/* {finalPrice.toFixed(2) ===
                                                product.price.toFixed(2) ? (
                                                  ''
                                                ):(
                                                   <span style={{color:'rgba(203, 28, 30, 1)'}}> &nbsp;( {product.discount} OFF)</span>
                                                )} */}
                                                </h2>
                                                <p className="productInfoRating d-flex align-items-center gap-1">
                                                    <ul
                                                        id="stars"
                                                        className="d-flex list-unstyled p-0 m-0"
                                                    >
                                                        <StartRating
                                                            productRating={
                                                                averageRating
                                                            }
                                                        />
                                                    </ul>
                                                    <span>{averageRating}</span>
                                                    <span>
                                                        ({numberOfReviews}{" "}
                                                        Reviews)
                                                    </span>
                                                </p>
                                                {finalPrice.toFixed(2) ===
                                                product.price.toFixed(2) ? (
                                                    <p className="productInfoRegular d-flex flex-column">
                                                        <span>
                                                            Regular Price:
                                                        </span>
                                                        <span>
                                                            TK{" "}
                                                            {regularPrice.toFixed(
                                                                2
                                                            )}
                                                        </span>
                                                    </p>
                                                ) : (
                                                    <>
                                                        <p className="productInfoFinalPrice d-flex flex-column">
                                                            <span>
                                                                Discount Price:
                                                            </span>
                                                            <span>
                                                                TK{" "}
                                                                {finalPrice.toFixed(
                                                                    2
                                                                )}
                                                            </span>
                                                            <span>
                                                                {finalPrice.toFixed(
                                                                    2
                                                                ) ===
                                                                product.price.toFixed(
                                                                    2
                                                                ) ? (
                                                                    ""
                                                                ) : (
                                                                    <span
                                                                        style={{
                                                                            color: "rgba(203, 28, 30, 1)",
                                                                        }}
                                                                    >
                                                                        {" "}
                                                                        {
                                                                            product.discount
                                                                        }{" "}
                                                                        OFF
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </p>

                                                        <p className="productInfoRegular d-flex flex-column">
                                                            <span>
                                                                Regular Price:
                                                            </span>
                                                            <span>
                                                                TK{" "}
                                                                {regularPrice.toFixed(
                                                                    2
                                                                )}
                                                            </span>
                                                        </p>
                                                    </>
                                                )}

                                                <p className="productInfoDeleveryTime">
                                                    Delivery Time:{" "}
                                                    <span>
                                                        {product.deleveryTime}
                                                    </span>
                                                    {product.deliveryTime}
                                                    <h2 className="productInfoDeleveryime"></h2>
                                                </p>
                                                <div className="quickOverView">
                                                    <h4>Quick Overview</h4>
                                                    <ul>
                                                        {product.quickOverview &&
                                                        product.quickOverview
                                                            .length > 0 ? (
                                                            product.quickOverview.map(
                                                                (
                                                                    item,
                                                                    index
                                                                ) => {
                                                                    const [
                                                                        key,
                                                                        value,
                                                                    ] =
                                                                        Object.entries(
                                                                            item
                                                                        )[0]; // Destructure key and value from each object
                                                                    return (
                                                                        <li
                                                                            key={
                                                                                index
                                                                            }
                                                                        >
                                                                            {
                                                                                key
                                                                            }{" "}
                                                                            -{" "}
                                                                            {
                                                                                value
                                                                            }
                                                                        </li>
                                                                    );
                                                                }
                                                            )
                                                        ) : (
                                                            <li>
                                                                No Quick
                                                                Overview
                                                                available
                                                            </li>
                                                        )}
                                                    </ul>
                                                </div>

                                                <div className="product-actions productInfoAddToCart d-flex gap-2">
                                                    <div
                                                        className="quantity-controls productInfoControls"
                                                        style={{
                                                            display: "flex",
                                                            alignItems:
                                                                "center",
                                                            gap: "10px",
                                                        }}
                                                    >
                                                        <button
                                                            className="minus"
                                                            onClick={
                                                                decreaseLocalQuantity
                                                            }
                                                            disabled={
                                                                quantity <= 1
                                                            }
                                                        >
                                                            <BsDashLg />
                                                        </button>
                                                        <span className="input-box">
                                                            {quantity}
                                                        </span>
                                                        <button
                                                            className="plus"
                                                            onClick={
                                                                increaseLocalQuantity
                                                            }
                                                        >
                                                            <BsPlusLg />
                                                        </button>
                                                    </div>
                                                    <button
                                                        className={`add-to-cart-btn ${
                                                            cartItem
                                                                ? "added"
                                                                : ""
                                                        }`}
                                                        onClick={
                                                            cartItem
                                                                ? handleRemoveProductDetails
                                                                : handleAddToCards
                                                        }
                                                    >
                                                        {cartItem ? (
                                                            <p>
                                                                <BsCartPlusFill />{" "}
                                                                Remove From Cart
                                                            </p>
                                                        ) : (
                                                            <p>
                                                                <AiOutlineShoppingCart />{" "}
                                                                Add To Cart
                                                            </p>
                                                        )}
                                                    </button>
                                                    <button
                                                        className="compare-btn"
                                                        onClick={
                                                            handleCompareProduct
                                                        }
                                                    >
                                                        <BsRepeat /> Compare
                                                    </button>
                                                    <button
                                                        className={`wishlist-btn ${
                                                            isWishlisted
                                                                ? "wishlisted"
                                                                : ""
                                                        }`}
                                                        onClick={
                                                            handleAddToWishlist
                                                        }
                                                    >
                                                        {isWishlisted ? (
                                                            <BsHeartFill />
                                                        ) : (
                                                            <BsHeart />
                                                        )}{" "}
                                                        {isWishlisted ? "" : ""}
                                                    </button>
                                                </div>
                                                <div className="btn-group-sop d-flex gap-1">
                                                    <button className="btn btn-primary">
                                                        <BsTruck /> Shipping &
                                                        Charge
                                                    </button>
                                                    <button className="btn btn-primary">
                                                        <BsCart2 /> Order
                                                        Procedure
                                                    </button>
                                                    <button className="btn btn-primary">
                                                        <BsWallet /> Payment
                                                        Method
                                                    </button>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab
                                            eventKey="home"
                                            title="Specifications"
                                        >
                                            <div className="product-tabs">
                                                {product.specifications &&
                                                product.specifications.length >
                                                    0 ? (
                                                    <div className="specifications-list">
                                                        {product.specifications.map(
                                                            (spec, index) => (
                                                                <div
                                                                    key={index}
                                                                    className="spec-item"
                                                                >
                                                                    <h3>
                                                                        {
                                                                            spec.title
                                                                        }
                                                                    </h3>
                                                                    {/* Check if the description is an array (list) or string */}
                                                                    {Array.isArray(
                                                                        spec.description
                                                                    ) ? (
                                                                        <ul>
                                                                            {spec.description.map(
                                                                                (
                                                                                    desc,
                                                                                    i
                                                                                ) => (
                                                                                    <li
                                                                                        key={
                                                                                            i
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            desc
                                                                                        }
                                                                                    </li>
                                                                                )
                                                                            )}
                                                                        </ul>
                                                                    ) : (
                                                                        <p>
                                                                            {
                                                                                spec.description
                                                                            }
                                                                        </p>
                                                                    )}
                                                                </div>
                                                            )
                                                        )}
                                                    </div>
                                                ) : (
                                                    <p>
                                                        No specifications
                                                        available for this
                                                        product.
                                                    </p>
                                                )}
                                            </div>
                                        </Tab>
                                        <Tab
                                            eventKey="compare"
                                            className="productComparenavbar"
                                            title="Product Compare"
                                        >
                                            <Compare compareLimit={4} />
                                            {compareItems.length >= 4 && (
                                                <div className="mt-3">
                                                    <Link to="/compare">
                                                        Go to Compare Page
                                                    </Link>
                                                </div>
                                            )}
                                            {/* {comparisonItems.length>=4 &&(
                                                <>
                                                 <Compare />
                                                 <Link to="/compare">Go to Compare Page</Link>
                                                </>
                                                
                                            )} */}
                                        </Tab>
                                        <Tab eventKey="contact" title="Q & A">
                                            <QandA productId={product.id} />
                                        </Tab>
                                        <Tab eventKey="review" title="Review">
                                            {/* <h4>Customer Reviews</h4>
                                            <p>
  <FaStar /> {averageRating} out of 5.0
</p>
<p>Total Reviews: {totalReviews}</p>
                                            <ReviewForm productId={product.id}/> */}
                                            <ReviewForm
                                                productId={product?.id}
                                            />

                                            {/* Optional: Display list of reviews */}
                                            {/* <div className="reviews-section">
                                                {product.reviewsList.map((review, index) => (
                                                    <div key={index} className="review-item">
                                                        <h5>{review.name}</h5>
                                                        <StartRating productRating={review.PersonRating} />
                                                        <p>{review.review}</p>
                                                    </div>
                                                ))}
                                            </div> */}
                                        </Tab>
                                    </Tabs>
                                    <br />
                                    <br />
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <br />
                            <br />
                            <h3>Related Products</h3>
                            <br />
                            <Slider {...relatedProductSettings}>
                                {relatedProducts.map((relatedProduct) => (
                                    <ProductCard
                                        key={relatedProduct.id}
                                        product={relatedProduct}
                                    />
                                ))}
                            </Slider>
                        </Col>
                    </Row>
                </Container>
                <Modal
                    show={showModal}
                    onHide={() => setShowModal(false)}
                    size="lg"
                    centered
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Product Images</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Popup Slick Slider */}
                        <Row>
                            <Col md={6} className="productimageslick">
                                <Slider
                                    {...settings}
                                    initialSlide={activeSlide}
                                >
                                    {combinedImages.map((image, index) => (
                                        <div key={index}>
                                            <ReactImageMagnify
                                                {...{
                                                    smallImage: {
                                                        alt: `Slide ${index}`,
                                                        isFluidWidth: true,
                                                        src: image,
                                                    },
                                                    largeImage: {
                                                        src: image,
                                                        width: 1000,
                                                        height: 1000,
                                                    },
                                                    enlargedImagePosition:
                                                        "over",
                                                    enlargedImageContainerDimensions:
                                                        {
                                                            width: "100%",
                                                            height: "100%",
                                                        },
                                                    enlargedImageContainerStyle:
                                                        {
                                                            zIndex: "999900",
                                                            width: "100%",
                                                            height: "100%",
                                                            left: "50%",
                                                            top: "50%",
                                                            transform:
                                                                "translate(-50%,-50%)",
                                                            border: "4px solid #f1f1f1",
                                                            backgroundColor:
                                                                "rgba(255, 255, 255, 0.8)",
                                                        },
                                                    enlargedImageStyle: {
                                                        objectFit: "contain",
                                                        width: "100%",
                                                        height: "100%",
                                                    },
                                                    lensStyle: {
                                                        backgroundColor:
                                                            "rgba(0, 0, 0, 1)",
                                                        border: "1px solid red",
                                                    },
                                                }}
                                            />
                                        </div>
                                    ))}
                                </Slider>
                            </Col>
                            <Col md={6} className="showzomingimg">
                                <div>
                                    <iframe
                                        width="100%"
                                        height="315"
                                        src="https://www.youtube.com/embed/ngElkyQ6Rhs"
                                        frameBorder="0"
                                        allowFullScreen
                                        title="Product Video"
                                    ></iframe>
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <br />
                    <br />
                    <br />
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() => setShowModal(false)}
                        >
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <br />
            <br />
            <br />
            <Footer />
        </>
    );
};

export default React.memo(ProductDetail);
